<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/system")
          i.fa.fa-desktop
          span.ml-1 {{ $t("ui.system") }}
      b-breadcrumb-item
        router-link(to="/system/user")
          i.fa.fa-users-cog
          span.ml-1 {{ $tc("ui.users", 2) }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-6.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="userSearch" :placeholder="$t('message.search_by_id_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="name") {{ $t("ui.name") }}
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.icon-people
                    b-form-select(v-model="filterRoleBy")
                      option(value="")
                        | {{ $t("ui.all") }}
                      option(v-for="roleInfo in roleList" v-bind:value="roleInfo.role_id")
                        | {{ roleInfo.role_name }}
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getUserList(true)"
                    variant="success"
                    size="sm"
                    )
          div.row
            div.col-md-12
              b-button(v-b-modal.addUser type="button" variant="primary" size="sm")
                i.fa.fa-plus
                span {{ $t("ui.combine.add_user") }}
        div.card-body.p-1
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="userTotalRow"
                :per-page="getPageSize"
                v-model="currentUserPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: auto;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position
                        span {{ $t('ui.id') }}
                      th.text-center.sticky-position(width=120)
                        span {{ $t("ui.action") }}
                      th.sticky-position(width=100)
                        span {{ $t("ui.status") }}
                      th.sticky-position
                        span {{ $t("ui.name") }}
                      th.text-center.sticky-position(width=100)
                        span {{ $t("ui.login_attempt") }}
                      th.text-center.sticky-position(width=100)
                        span {{ $t("ui.validated") }}
                      th.text-right.sticky-position(width=200)
                        span {{ $t("ui.validated_at") }}
                      th.text-right.sticky-position(width=200)
                        span {{ $t("ui.created_on") }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in userList")
                      td
                        span {{ item.user_id }}
                      td.actions
                        span
                          a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                        span
                          a.fa.fa-lock.text-warning(href="#" @click="onPassword(item)" :title="$t('ui.password')")
                        span
                          a.fa.fa-id-card.text-info(href="#" @click="onAssign(item)" :title="$tc('ui.roles', 2)")
                      td
                        select(@change="changedStatus(item, $event)" :value="item.user_status")
                          option(value="ACTIVE") {{ $t("ui.active") }}
                          option(value="DISABLED") {{ $t("ui.disabled") }}
                          option(value="BLOCKED") {{ $t("ui.blocked") }}
                          option(value="SUSPENDED") {{ $t("ui.suspended") }}
                      td
                        span {{ item.user_name }}
                      td.text-center
                        span {{ item.login_attempt }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.validated, 'fas fa-times text-warning': !item.validated  }")
                      td.text-right
                        span(v-if="item.validated_at") {{ $moment(item.validated_at).format("YYYY-MM-DD, HH:mm:ss") }}
                      td.text-right
                        span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
    adduser(@clicked="addUser" @failed="handleFailed")
    edituser(ref="edituser" :userId="editSelectedId" :userName="editSelectedName" @clicked="updateUser" @failed="handleFailed")
    edituser(ref="edituser" :userId="editSelectedId" :userName="editSelectedName" @clicked="updateUser" @failed="handleFailed")
    changepwduser(ref="changepwduser" :userId="editSelectedId" :userName="editSelectedName" @clicked="updatePwdUser" @failed="handleFailed")
    assignuserrole(ref="assignuserrole" :userId="editSelectedId" :userName="editSelectedName" @clicked="updateUserRole" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import adduser from "@/components/user/addUser.vue";
import edituser from "@/components/user/editUser.vue";
import changepwduser from "@/components/user/changePwdUser.vue";
import assignuserrole from "@/components/user/assignUserRole.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    adduser,
    edituser,
    changepwduser,
    assignuserrole,
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    userStatus: [
      {
        value: "ACTIVE",
        text: "ACTIVE"
      },
      {
        value: "DISABLED",
        text: "DISABLED"
      },
      {
        value: "BLOCKED",
        text: "BLOCKED"
      },
      {
        value: "SUSPENDED",
        text: "SUSPENDED"
      }
    ],
    filterBy: "id",
    filterRoleBy: "",
    roleList: [],
    userList: [],
    currentUserPage: 1,
    userTotalRow: 0,
    userSearch: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedId: "",
    editSelectedName: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    this.getUserList();
    this.getRoleList();
  },
  methods: {
    onEdit(e) {
      this.editSelectedId = e.user_id;
      this.editSelectedName = e.user_name;
      this.$refs.edituser.$refs.editUser.show();
    },
    onPassword(e) {
      this.editSelectedId = e.user_id;
      this.editSelectedName = e.user_name;
      this.$refs.changepwduser.$refs.changePwdUser.show();
    },
    onAssign(e) {
      this.editSelectedId = e.user_id;
      this.editSelectedName = e.user_name;
      this.$refs.assignuserrole.$refs.assignUserRole.show();
    },
    getRoleList: function() {
      let url = config.roleListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.user
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.roleList = response.data.tbl_role_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getUserList: function(isSearch) {
      let url = config.userListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentUserPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.user,
        user_id: "",
        user_name: "",
        role_id: this.filterRoleBy,
        page_number: this.currentUserPage,
        page_size: this.getPageSize
      };

      if (this.filterBy == "id") {
        json.user_id = this.userSearch;
      } else {
        json.user_name = this.userSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.userList = response.data.tbl_user_list;
                this.userTotalRow = this.userList.length > 0 ? this.userList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentUserPage = 1;
      this.getUserList();
    },
    changedPage: function(pageNo) {
      this.currentUserPage = pageNo;
      this.getUserList();
    },
    changedStatus: function(user, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_user_status_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.submit(user, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = user.user_status;
          }
        });
    },
    submit: function(user, status) {
      let url = config.editUserStatusUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.user,
        user_id: user.user_id,
        user_status: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                user.user_status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addUser: function(userId, userName) {
      let newUser = {
        user_id: userId,
        user_name: userName,
        user_status: "ACTIVE",
        login_attempt: 0,
        created_on: new Date()
      };

      this.userSearch = "";
      this.currentUserPage = 1;
      this.userList.unshift(newUser);

      this.$helpers.showDialog(this.$t("ui.combine.add_user"), this.$t("message.success"), "success");
    },
    updateUser: function(userId, userName) {
      this.userList.filter(function(userInfo) {
        if (userInfo.user_id == userId) {
          userInfo.user_name = userName;
        }
      });

      this.$helpers.showDialog(this.$t("ui.combine.edit_user"), this.$t("message.success"), "success");
    },
    updatePwdUser: function() {
      this.$helpers.showDialog(this.$t("ui.password"), this.$t("message.success"), "success");
    },
    updateUserRole: function() {
      this.$helpers.showDialog(this.$t("ui.combine.assign_roles"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>